module.exports = __webpack_public_path__ + "img/dsh.ac38dad2.png";